import { useContext } from "react";
import { http } from "~/services/http";
import useSWRMutation from "swr/mutation";
import { PreviewModeContext, isLiveMode } from "~/context/PreviewModeContext";

const fetcher = (url, { arg }) =>
  http.postWithProgress(
    url,
    arg.formData,
    arg.progressHandler,
    arg.abortCallback
  );

export const useUploadFile = () => {
  const { mode } = useContext(PreviewModeContext);
  const isPreviewOrPrint = !isLiveMode(mode);

  // SWR's mutation hook doesn't fire on mount, but the trigger must be a
  // no-op in preview/print so widget code paths that call upload() don't
  // accidentally POST.
  const swrKey = isPreviewOrPrint ? null : "/api/studyfile";
  const {
    trigger: upload,
    isMutating: isUploading,
    error,
  } = useSWRMutation(swrKey, fetcher);

  if (isPreviewOrPrint) {
    return {
      upload: () => Promise.resolve(null),
      isUploading: false,
      error: null,
    };
  }

  return { upload, isUploading, error };
};
